import './label.scss';
import FontBody3 from '../fonts/font-body3/font-body3';
import { FONT_COLOR } from '../fonts/font-props';

/**
 * Generic Label component.
 *
 * Visual configuration is controlled strictly via enums so that only
 * predefined and design-approved variants can be used.
 */
export enum LABEL_VARIANT {
	DARK_BLUE = 'label-dark-blue',
	ACCENT = 'label-accent',
	ACCENT_OUTLINED = 'label-accent-outlined',
	ACCENT_LIGHT = 'label-accent-light',
	GRAY = 'label-gray',
}

export interface ILabelProps {
	/** Text content of the label. */
	labelText: string;
	/** Visual style variant of the label. */
    variant: LABEL_VARIANT;
}

const Label: React.FC<ILabelProps> = ({ labelText, variant }) => {
    return (
        <div className={`label-rms ${variant}`}>
            <FontBody3 color={getFontColor(variant)}>{labelText}</FontBody3>
        </div>
    );
};

function getFontColor(variant: LABEL_VARIANT): FONT_COLOR | undefined {
    switch (variant) {
        case LABEL_VARIANT.DARK_BLUE:
            return FONT_COLOR.NEUTRAL_1_WHITE;
        case LABEL_VARIANT.ACCENT:
            return FONT_COLOR.NEUTRAL_1_WHITE;
        case LABEL_VARIANT.ACCENT_OUTLINED:
            return FONT_COLOR.ACCENT1;
        case LABEL_VARIANT.ACCENT_LIGHT:
            return FONT_COLOR.ACCENT1;
        case LABEL_VARIANT.GRAY:
            return FONT_COLOR.PRIMARY2;
        default:
            return undefined;
    }
}

export default Label;


